import { Button } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../components/modal/Dialog";
import { useDeliveryAreaDelete } from "../../../hooks/api/v2/deliveryArea/useDeliveryAreaDelete";

export const DeliveryScheduleDeleteDialog = ({
  deliveryScheduleId,
  deliveryScheduleName,
  active,
  setActive,
}: {
  deliveryScheduleId: number;
  deliveryScheduleName: string;
  active: boolean;
  setActive: (active: boolean) => void;
}) => {
  const deleteDeliveryAreaMutation = useDeliveryAreaDelete(deliveryScheduleId);

  return (
    <>
      <Dialog active={active} onDismiss={() => setActive(false)}>
        <DialogNavigation
          leftIcon="CHEVRON_DOWN"
          onClickLeftIcon={() => setActive(false)}
          title={`Delete ${deliveryScheduleName}?`}
          description={`Are you sure you want to delete ${deliveryScheduleName} delivery schedule`}
        />
        <DialogContent>
          <div className="flex justify-end">
            <Button
              color="red"
              loading={deleteDeliveryAreaMutation.isPending}
              onClick={() => {
                deleteDeliveryAreaMutation.mutate(undefined, {
                  onSuccess: () => {
                    setActive(false);
                  },
                });
              }}
            >
              Delete
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
